import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import { Form, Errors, LocalForm, Control, actions, Field } from 'react-redux-form';
 
import { Provider } from 'react-redux';

@withRouter
export class Search extends React.Component<any, any> {
    formDispatch;
    constructor(props) {
        super(props);
        this.onLocalSubmit = this.onLocalSubmit.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onLocalSubmit(values) {
        this.onSubmit(values);
    }

    async onSubmit(form) {
        // if there is no forum then send through the user - this is probably confusing
        let id = this.props.forum ? this.props.forum.id : this.props.currentUser.email;
        if(this.props.forum) {
            this.props.search(id, form.search);
        }
        document.getElementById("searchBtn").focus();
    }

    componentDidUpdate(prevProps, prevState){
        // check if the function changed
        if(prevProps.search != this.props.search){
            this.formDispatch(actions.reset('search'));
            this.formDispatch(actions.load('search.search', this.props.text));
        }
    }

    render() {
        const { location, children, search, text, ...props } = this.props;

        return (<LocalForm model="search" 
                    onSubmit={this.onLocalSubmit.bind(this)} 
                    getDispatch={(dispatch) => this.formDispatch = dispatch}>
                    <div className="search input-group mb-2">
                        <Control.text type="search" model=".search" id="search" className="form-control lightgrey-bg" placeholder="Search..." />
                        <button type="submit" id="searchBtn" className="input-group-addon btn btn-white"><span className="fa fa-search"></span></button>
                    </div>
                </LocalForm>);
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Search.tsx